module.exports = __webpack_public_path__ + "img/image.6a33269d.svg";